export const BlogCategory =[
    {id:"1", name:"Popular tags"},
    {id:"2", name:"Covid-19"},
    {id:"3", name:"Versions"},
    {id:"4", name:"Distributions"},
]